const BadgeType = Object.freeze({ WARNING: 0, INFO: 1 });
export default BadgeType;



// WEBPACK FOOTER //
// ./components/AcademicOverviewBadge/type.jsx